<template>
    <ui5-card class="customer-search">
        <div>
            <h2>{{ config.title }}</h2>
            <div class="search-fields">
                <ui5-input
                    v-for="field in Object.keys(config.fields)"
                    :key="'field.' + config.key + '.' + field"
                    @focus="search.cancel()"
                    type="Text"
                    @change="search"
                    :value="config.fields[field]"
                    @input="config.fields[field] = $event.target.value"
                    :disabled="config.loading"
                    :placeholder="config.placeholders[field]"
                />
            </div>
            <spinner-text v-if="config.loading">
                {{ config.loadingLabel }}
            </spinner-text>
            <template v-else-if="config.items">
                <div v-if="config.items.length == 0">
                    Geen klanten gevonden met de opgegegeven voorwaarden
                </div>
                <ui5-list
                    v-else
                    growing="Scroll"
                >
                    <ui5-li
                        v-for="customer in config.items"
                        @click="action(customer)"
                        :key="'customer.' + customer.customerId"
                    >
                        {{ customer.customerId }}, {{ customer.customerName }}
                    </ui5-li>
                </ui5-list>
            </template>
        </div>
    </ui5-card>
</template>
<script>
import SpinnerText from '../loader/SpinnerText';
import customerApi from '../../api/customer';
import { showErrorMessage } from '../../dialogs';
import _ from 'lodash';

export default {
    components: { SpinnerText },
    props: ['config', 'action'],
    data() {
        return {
            search: _.debounce(this.searchCustomer, 500),
        };
    },
    methods: {
        searchCustomer() {
            const payload = { ...this.config.fields };
            if (
                Object.values(payload).filter((x) => x.length >= 2).length == 0
            ) {
                return showErrorMessage(
                    'Minstens een van de zoekvelden moet twee of meer karakters bevatten'
                );
            }
            this.config.loading = true;
            customerApi
                .listCustomers(payload)
                .then((response) => {
                    this.config.items = response.data.data;
                })
                .catch(() => {
                    showErrorMessage('Zoeken naar klanten mislukt');
                })
                .finally(() => {
                    this.config.loading = false;
                });
        },
    },
};
</script>
